import { INSM } from './insm';
var initialisedInsm;

/**
 * Initializes the INSM (Interactivity Session Measurement) tooling
 */
export function init(options) {
  initialisedInsm = new INSM(options);
}
function insmInitialised() {
  if (!initialisedInsm) {
    // eslint-disable-next-line no-console
    console.error('INSM used when not initialised');
    return false;
  }
  return true;
}

/**
 * **In**teractivity **s**ession **m**onitoring
 */
export var insm = {
  startHeavyTask: function startHeavyTask(heavyTaskName) {
    if (insmInitialised()) {
      initialisedInsm.startHeavyTask(heavyTaskName);
    }
  },
  endHeavyTask: function endHeavyTask(heavyTaskName) {
    if (insmInitialised()) {
      initialisedInsm.endHeavyTask(heavyTaskName);
    }
  },
  start: function start(experienceKey, experienceProperties) {
    if (insmInitialised()) {
      initialisedInsm.start(experienceKey, experienceProperties);
    }
  },
  stopEarly: function stopEarly(reasonKey, description) {
    if (insmInitialised()) {
      initialisedInsm.stopEarly(reasonKey, description);
    }
  },
  // We only expose details and feature start/stop to consumers
  // as the other properties are internals for the insm and InsmPeriod
  // to interact with the running session.
  get session() {
    if (insmInitialised()) {
      return initialisedInsm.runningSession;
    }
  },
  // @ts-expect-error Private method for testing purposes
  __setAnalyticsWebClient: function __setAnalyticsWebClient(analyticsWebClient) {
    if (initialisedInsm) {
      initialisedInsm.analyticsWebClient = analyticsWebClient;
    }
  }
};